import { render, staticRenderFns } from "./IconContainer.vue?vue&type=template&id=04f76f61&scoped=true&"
import script from "./IconContainer.vue?vue&type=script&lang=js&"
export * from "./IconContainer.vue?vue&type=script&lang=js&"
import style0 from "./IconContainer.vue?vue&type=style&index=0&id=04f76f61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f76f61",
  null
  
)

export default component.exports